// extracted by mini-css-extract-plugin
export default {"tasksPanel":"WarehouseTasksPanel_tasksPanel__+DWpX","linkColumn":"WarehouseTasksPanel_linkColumn__iGe2Q"};